<script setup>
import {inject} from 'vue';
import {XCircleIcon} from '@heroicons/vue/24/outline';

const props = defineProps({
    modalClass: {
        type: String,
        required: false,
        default: 'xl:max-w-5xl',
    },
});

const modalVideoState = inject('modalVideoState');
</script>

<template>
    <Transition>
        <div id="modal" v-if="modalVideoState.isVisible" class="modal">
            <div class="backdrop inset-0 z-1000 bg-violet/75 fixed top-0 left-0 w-screen h-screen">

            </div>

            <div class="fixed inset-0 z-1100 top-0 left-0 w-screen h-screen overflow-y-auto">
                <div class="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
                    <div
                        :class="['relative transform overflow-hidden rounded-xl bg-transparent text-left shadow-xl  transition-all sm:my-8 w-full sm:max-w-lg', modalClass]">
                        <div
                            class="modal-header bg-transparent text-white text-center text-4xl font-bold py-8 px-6 lg:px-12 leading-tight">
                            <button @click="modalVideoState.isVisible = !modalVideoState.isVisible"
                                    class="p-1 text-white font-bold leading-tight absolute right-2 top-2">
                                <div class="w-10 hover:scale-125 hover:text-white transition-all duration-500">
                                    <x-circle-icon></x-circle-icon>
                                </div>
                            </button>
                        </div>
                        <div class="modal-content bg-transparent p-0"
                             data-target="replace-with-content">
                             <component
                                :is="modalVideoState.component"
                                v-bind="modalVideoState.props"
                             ></component>
                        </div>
                        <div class="modal-footer px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 justify-center">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }
</style>
